import React, { useState } from 'react';
import { useCollection, useEvent, useEvents, useGeoObjectCoords, useGeoObjectOptions, useGeoObjectProperties } from '../../hooks';
var Polygon = function (_a) {
    var onClick = _a.onClick, coords = _a.coords, properties = _a.properties, options = _a.options, events = _a.events;
    var geoObject = useState(function () {
        return new ymaps.Polygon(coords, properties, options);
    })[0];
    useCollection(geoObject);
    useEvent(geoObject, 'click', onClick);
    useEvents(geoObject, events);
    useGeoObjectCoords(geoObject, coords);
    useGeoObjectOptions(geoObject, options);
    useGeoObjectProperties(geoObject, properties);
    return null;
};
export default React.memo(Polygon);
